import { render, staticRenderFns } from "./pinpuChats.vue?vue&type=template&id=76cb573a&scoped=true"
import script from "./pinpuChats.vue?vue&type=script&lang=js"
export * from "./pinpuChats.vue?vue&type=script&lang=js"
import style0 from "./pinpuChats.vue?vue&type=style&index=0&id=76cb573a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cb573a",
  null
  
)

export default component.exports